import { ReactElement, useState } from 'react';

import { Tooltip, Typography } from '@mui/material';

const MAX_STRING_SIZE = 50;

interface RegularTextProps {
  children: ReactElement | string | unknown;
  [x: string]: unknown;
}

export const RegularText = ({ children, ...props }: RegularTextProps) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (typeof children === 'string' && children.length > MAX_STRING_SIZE) {
      setOpen(true);
    }
  };

  return (
    <Tooltip open={open} onClose={handleClose} onOpen={handleOpen} title={(children as ReactElement) || ''}>
      <Typography variant="body1" {...props}>
        {typeof children === 'string'
          ? `${children.substring(0, MAX_STRING_SIZE)}${children.length > MAX_STRING_SIZE ? '...' : ''}`
          : (children as ReactElement)}
      </Typography>
    </Tooltip>
  );
};
